/**
 * collection-subcollections — expand / collapse extra pills on small screens.
 */
(function () {
  document.querySelectorAll('[data-subcollections-nav]').forEach(function (nav) {
    var toggle = nav.querySelector('[data-subcollections-toggle]');
    var label = nav.querySelector('[data-subcollections-label]');
    var icon = nav.querySelector('.collection-subcollections__expand-icon');
    if (!toggle || !label) return;

    var moreText = nav.getAttribute('data-label-more') || '';
    var fewerText = nav.getAttribute('data-label-fewer') || '';

    toggle.addEventListener('click', function () {
      var expanded = nav.classList.toggle('collection-subcollections--expanded-mobile');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? fewerText : moreText;
      nav.classList.toggle('collection-subcollections--collapsed-mobile', !expanded);
      if (icon) {
        icon.style.transform = expanded ? 'rotate(180deg)' : '';
      }
    });
  });
})();
